import { render, staticRenderFns } from "./insureDialog.vue?vue&type=template&id=1f31c580&"
import script from "./insureDialog.vue?vue&type=script&lang=js&"
export * from "./insureDialog.vue?vue&type=script&lang=js&"
import style0 from "./insureDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports